import React from 'react';
import {
  Modal,
  Button,
} from 'antd';
import { SpText } from 'components/DesignKit';

type Props = {
  uploadGuidelineModalVisibility: Boolean,
  setUploadGuidelineModalVisibility: Function,
  setAddFileModalVisibility: Function,
};

const DisplayUploadGuildelines = (props: Props) => {
  const {
    uploadGuidelineModalVisibility,
    setUploadGuidelineModalVisibility,
    setAddFileModalVisibility,
  } = props;


  const handleUploadGuidelineModalCancel = () => {
    setUploadGuidelineModalVisibility(false);
  };

  const handleUploadGuidelineModalSave = () => {
    setAddFileModalVisibility(true);
    setUploadGuidelineModalVisibility(false);
  };

  return (
    <Modal
      title="Upload Guidelines"
      visible={uploadGuidelineModalVisibility}
      onCancel={handleUploadGuidelineModalCancel}
      footer={[
        <Button key="ok" type="primary" onClick={handleUploadGuidelineModalSave}>
          OK
        </Button>,
      ]}
      centered
      maskClosable={false}
      closable
    >
      <div style={{ padding: '20px' }}>
        <SpText style={{ fontWeight: 'bolder', display: 'block', marginBottom: '12px' }}>
          To ensure accurate processing, please upload only one invoice per vendor per store location at a time.
        </SpText>
        <SpText style={{ fontWeight: 'bolder', display: 'block', marginBottom: '12px' }}>
          If your invoice has multiple pages, you can include them in a single file.
        </SpText>
        <SpText style={{ fontWeight: 'bolder', display: 'block', marginBottom: '12px' }}>
          This helps us process your data accurately and efficiently.
        </SpText>
      </div>
    </Modal>
  );
};

export default DisplayUploadGuildelines;
